/* React */
import React, { forwardRef } from "react";

/* Ionic */
import { IonIcon } from "@ionic/react";
import { chevronExpand } from "ionicons/icons";

/* Stylesheet */
import styles from "./ResizerButton.module.scss";

const ResizerButton = forwardRef<HTMLDivElement>(
  (_props, ref) => {
    return (
      <div className={styles.resizer_button} ref={ref}>
        <IonIcon
          className={styles.icon}
          icon={chevronExpand}
        />
      </div>
    );
  }
);

ResizerButton.displayName = "ResizerButton";
export default ResizerButton;
